import { render, staticRenderFns } from "./starComponents.vue?vue&type=template&id=c9c7b148&scoped=true&lang=pug&"
import script from "./starComponents.vue?vue&type=script&lang=js&"
export * from "./starComponents.vue?vue&type=script&lang=js&"
import style0 from "./starComponents.vue?vue&type=style&index=0&id=c9c7b148&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c9c7b148",
  null
  
)

export default component.exports